module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "width": "160px",
      "margin": "10px"
    },
    on: {
      "click": _vm.NewPatient
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('span', [_vm._v("Add New Patient ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "width": "160px",
      "margin": "10px"
    },
    on: {
      "click": function($event) {
        _vm.refreshIndex = _vm.refreshIndex + 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" "), _c('span', [_vm._v("Refresh ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr'), _vm._v(" "), _c('ServerDatatable', {
    attrs: {
      "columns": _vm.columns,
      "source": _vm.getRecords,
      "datachanged": _vm.refreshIndex
    },
    on: {
      "selected": _vm.patientSelected
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2663973a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2663973a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/FmdControls/Patients/Patients.scp.html
// module id = 523
// module chunks = 0